$eve_input_logical_switch_labelled $eve_button
	variant \ghost
	size? \m
	justify_content \flex-start
	sub /
		<= Switch $eve_input_logical_switch
			checked? <=> checked? false
			disabled? <=> disabled? false
		<= Label
